// Quick sign-in: a 4–6 digit PIN a user set for this device after a full sign-in.
// This browser keeps the key the server issued for the device, the PIN row's id and
// who it is for (to greet them on the sign-in page). The PIN itself is never stored.
// Sign-out keeps it on purpose: it is how the next sign-in skips the password.

const KEY = "quickSignIn";
// "Not now" on the offer after a full sign-in; asked once per device.
const DECLINED_KEY = "quickSignIn.declined";
// Set by a full sign-in (password or code) so the app offers a PIN once.
const OFFER_KEY = "quickSignIn.offer";

export const readQuickSignIn = () => {
  try {
    const value = JSON.parse(localStorage.getItem(KEY) || "null");
    return value?.deviceKey ? value : null;
  } catch (_e) {
    return null;
  }
};

export const saveQuickSignIn = (entry) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(entry));
    localStorage.removeItem(DECLINED_KEY);
  } catch (_e) {
    /* private mode / quota: quick sign-in just isn't remembered */
  }
};

export const forgetQuickSignIn = () => {
  try {
    localStorage.removeItem(KEY);
  } catch (_e) {
    /* ignore */
  }
};

export const markFullSignIn = () => {
  try {
    sessionStorage.setItem(OFFER_KEY, "1");
  } catch (_e) {
    /* ignore */
  }
};

export const shouldOfferQuickSignIn = () => {
  try {
    return (
      sessionStorage.getItem(OFFER_KEY) === "1" &&
      !readQuickSignIn() &&
      localStorage.getItem(DECLINED_KEY) !== "1"
    );
  } catch (_e) {
    return false;
  }
};

export const dismissQuickSignInOffer = (declined) => {
  try {
    sessionStorage.removeItem(OFFER_KEY);
    if (declined) localStorage.setItem(DECLINED_KEY, "1");
  } catch (_e) {
    /* ignore */
  }
};
